import type { Absence } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'
import { ABSENCES_QUERY_KEY, ABSENCES_URL } from './queryConstants'

type UseAbsenceDetailProps = {
  absenceId: string | undefined
}

type UseAbsenceDetailReturn = {
  absence: Absence | undefined
  isAbsenceLoading: boolean
  refetch: () => void
}

export const useAbsenceDetail = ({
  absenceId
}: UseAbsenceDetailProps): UseAbsenceDetailReturn => {
  // SINGLE ABSENCE
  const {
    data: absence,
    isLoading: isAbsenceLoading,
    refetch
  } = useQuery(
    [ABSENCES_QUERY_KEY, absenceId] as string[],
    () =>
      getJSON({
        url: `${ABSENCES_URL}/${absenceId}`,
        isRota: true
      }),
    { enabled: true }
  )

  return {
    absence: absence?.data || undefined,
    isAbsenceLoading,
    refetch
  }
}
